<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const storyFramework = [
  "Opening situation",
  "Problem or conflict",
  "Turning point",
  "Ending",
  "Moral",
];

const commonMorals = [
  "Honesty is the best policy.",
  "Unity is strength.",
  "As you sow, so shall you reap.",
  "Greed leads to grief.",
];

const examTips = [
  "Story ko 4-5 connected paragraphs me likho.",
  "Moral end me clearly separate line me dena useful hota hai.",
  "Overlong introduction se bachna chahiye; direct plot start karo.",
];

const commonPrompts = [
  "A friend in need is a friend indeed.",
  "Union is strength.",
  "Greed is a curse.",
  "Slow and steady wins the race.",
];

const commonMistakes = [
  "Plot ko beech me abruptly khatam kar dena.",
  "Moral ko missing chhor dena.",
  "Outline se irrelevant detail add kar dena.",
];

const miniStory = [
  "A thirsty crow was flying in search of water.",
  "He saw a pitcher with a little water at the bottom.",
  "He could not reach the water with his beak.",
  "He dropped small stones into the pitcher until the water rose up.",
  "He drank the water happily.",
  "Moral: Where there is a will, there is a way.",
];

usePageSeo({
  title: "11th Class English Story Writing | Moral Stories, Format and Tips",
  description: "11th class English story writing page with structure, common prompts, moral lines, sample direction and exam-focused tips.",
  keywords: "11th class english story writing, class 11 moral stories, english composition story writing, story writing format",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
    { name: "Story Writing", item: "/11th/english/grammar/story-writing/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Grammar Task"
      title="Story Writing"
      description="Story writing section me prompt ko complete plot me convert karna hota hai. Focus structure, sequence aur clear moral par rehna chahiye."
    />

    <EnglishSection title="Basic Framework" description="Use this sequence to keep the story complete and coherent.">
      <EnglishGrid>
        <EnglishCard v-for="item in storyFramework" :key="item" title="Framework" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Moral Lines" description="These lines can help when you need a strong ending.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonMorals" :key="item" title="Moral" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Exam Tips" description="These rules help keep the answer short, direct, and scoring-friendly.">
      <EnglishGrid>
        <EnglishCard v-for="item in examTips" :key="item" title="Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Story Prompts" description="Use these prompts for quick exam-style practice.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonPrompts" :key="item" title="Prompt" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Mini Model Story" description="A compact model showing how the plot can be built step by step.">
      <EnglishLinkList :links="miniStory.map((line) => ({ label: line }))" />
    </EnglishSection>

    <EnglishSection title="Common Mistakes" description="Avoid these if you want the story to stay aligned with the prompt.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonMistakes" :key="item" title="Mistake" :description="item" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
